"use client";

import {
  type CreateAsParams,
  type SellerAgentParams,
  useNewListingButton,
} from "@/app/(saas)/(app)/(common)/my-listings/_hooks/use-new-listing-button";
import { Button, type ButtonProps } from "@/components/ui/button";
import type { DetailedOwnListing } from "@/lib/types";
import { useRouter } from "next/navigation";
import { useProfessionalDesk } from "@/hooks/use-professional-desk";

export type NewListingButtonProps = ButtonProps & {
  createAs?: CreateAsParams | undefined; // agent creates listing for seller
  sellerAgent?: SellerAgentParams | undefined; // seller creates listing for agent

  onDone?: (listing: DetailedOwnListing) => void | Promise<void>;
};

export function NewListingButton({
  children,
  createAs,
  sellerAgent,
  onDone,
  ...rest
}: NewListingButtonProps) {
  const { createListing, isDisabled } = useNewListingButton();
  const desk = useProfessionalDesk();

  const router = useRouter();

  function handleListingCreated(listing: DetailedOwnListing) {
    const returnTo = desk.isProfessional
      ? `?returnTo=${encodeURIComponent(desk.listingsHref)}`
      : "";

    router.push(`/manage-listing/${listing.id}/business/location${returnTo}`);
    onDone?.(listing);
  }

  return (
    <Button
      {...rest}
      onClick={() => createListing(createAs, sellerAgent, handleListingCreated)}
      disabled={isDisabled}
    >
      {children}
    </Button>
  );
}

NewListingButton.displayName = "NewListingButton";
